/**
 * Cartes boissons — retournement au clic.
 *
 * La carte entière est un <button aria-expanded> : le CSS fait tourner les deux
 * faces, le JS ne tient que l'état et la face annoncée. Enter et Espace sont
 * gérés par le bouton lui-même, rien à ajouter.
 */
(() => {
  const pivots = [...document.querySelectorAll('[data-oyw-boisson]')];
  if (pivots.length === 0) return;

  /**
   * Bascule une carte.
   *
   * Les deux faces restent dans le DOM pour la rotation : sans aria-hidden, un
   * lecteur d'écran lirait le recto et le verso à la suite.
   */
  const retourner = (pivot, ouvert) => {
    pivot.setAttribute('aria-expanded', String(ouvert));
    const recto = pivot.querySelector('[data-oyw-face="recto"]');
    const verso = pivot.querySelector('[data-oyw-face="verso"]');
    if (recto) recto.setAttribute('aria-hidden', String(ouvert));
    if (verso) verso.setAttribute('aria-hidden', String(!ouvert));
  };

  pivots.forEach((pivot) => {
    pivot.addEventListener('click', () => {
      const ouvert = pivot.getAttribute('aria-expanded') === 'true';
      // Une seule carte retournée à la fois : la rangée reste lisible.
      if (!ouvert) {
        pivots.forEach((autre) => {
          if (autre !== pivot) retourner(autre, false);
        });
      }
      retourner(pivot, !ouvert);
    });
  });

  // Échap referme, comme sur la modale de rendez-vous.
  document.addEventListener('keydown', (evenement) => {
    if (evenement.key !== 'Escape') return;
    pivots.forEach((pivot) => {
      if (pivot.getAttribute('aria-expanded') === 'true') retourner(pivot, false);
    });
  });
})();
